<template>
  <div
    :class="
      isMobile ? 'loginContainer mobile_loginContainer' : 'loginContainer'
    "
  >
    <div :class="isMobile ? 'title mobileTitle' : 'title'">登录</div>
    <el-form
      ref="ruleForm"
      label-position="top"
      label-width="80px"
      :model="form"
    >
      <el-form-item prop="mobilePhone" label="手机号码">
        <el-input maxlength="11" v-model="form.mobilePhone"></el-input>
      </el-form-item>
      <el-form-item prop="password" label="登录密码">
        <el-input show-password v-model="form.password"></el-input>
      </el-form-item>
      <el-form-item>
        <el-form-item>
          <el-button class="submit" @click="submitForm('ruleForm')"
            >登录</el-button
          >
        </el-form-item>
      </el-form-item>
    </el-form>
    <el-button @click="handleCancel" class="cancel">取消</el-button>
    <div @click="forgetPassword" class="forget">忘记密码</div>
    <div class="baseLine"><div class="word">或</div></div>
    <button @click="goCreate" class="create">创建账户</button>
  </div>
</template>

<script>
import { apiLogin, loginAdminLogin } from "../../api/index";
import toast from "../../utils/toast";
export default {
  data() {
    return {
      form: {
        mobilePhone: "",
        password: ""
      }
    };
  },
  computed: {
    isMobile: function() {
      return this.$store.state.isMobile;
    }
  },
  methods: {
    goCreate() {
      if (this.$route.query.free) {
        this.$router.push({
          path: "/createAccount",
          query: {
            free: true
          }
        });
      } else {
        this.$router.push("/createAccount");
      }
    },
    forgetPassword() {
      this.$router.push("/forgetPassword");
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.$route.query.free) {
            let params = {
              accountNum: this.form.mobilePhone,
              password: this.form.password
            };
            // console.log(
            //   process.env.VUE_APP_PROJECTAPI_URL,
            //   "process.env.VUE_APP_PROJECTAPI_URL"
            // );
            fetch(process.env.VUE_APP_PROJECTAPI_URL + "/login/adminLogin", {
              method: "post",
              body: JSON.stringify(params),
              headers: {
                "Content-Type": "application/json"
              }
            })
              .then(res => res.json())
              .then(res => {
                if (!res.data.accessToken) {
                  this.$message({
                    type: "warning",
                    message: "请输入正确的账号密码"
                  });
                  return;
                }
                console.log(res.data, "============");
                // 本地

                window.open(
                  `${process.env.VUE_APP_PROJECT_URL}?token=${res.data.accessToken}&account=${this.form.mobilePhone}&password=${this.form.password}`
                );
                apiLogin(this.form).then(res => {
                  if (res.success) {
                    toast("登录成功", "success");
                    res.data.mobilePassword = this.form.password;
                    this.$store.commit("edit_user", res.data);
                    this.$router.push("/");
                  }
                });
              });
          } else {
            apiLogin(this.form).then(res => {
              if (res.success) {
                toast("登录成功", "success");
                res.data.mobilePassword = this.form.password;
                console.log(res.data, "=======");
                this.$store.commit("edit_user", res.data);
                this.$router.push("/");
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel() {
      this.$router.go(-1);
    }
  },
  mounted() {
    this.$store.commit("edit_backgroundColor", "#3e3e3e");
    if (this.isMobile) {
      this.$store.commit("edit_showTop", false);
    }
  },
  destroyed() {
    this.$store.commit("edit_backgroundColor", "rgba(0, 0, 0, 1)");
  }
};
</script>

<style lang="less">
.loginContainer {
  max-width: 430px;
  margin: 0 auto;
  padding-top: 116px;
  input {
    background-color: #f6f6f6;
    border: none;
  }
  .title {
    font-size: 34px;
  }
  .mobileTitle {
    font-size: 0.32rem;
  }
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    content: "";
  }
  .el-form-item__label {
    padding: 0;
  }
  .submit {
    width: 100%;
    color: #fff;
    background: #fc9900;
    margin-top: 10px;
  }
  .cancel {
    width: 100%;
    background: #f6f6f6;
    border: none;
  }
  .forget {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.65);
    text-align: center;
    margin: 16px 0 24px;
    cursor: pointer;
  }
  .baseLine {
    width: 100%;
    height: 1px;
    position: relative;
    background: #d8d8d8;
    margin-bottom: 74px;
    .word {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      padding: 0 8px;
      background-color: #fff;
    }
  }
  .create {
    width: 100%;
    height: 40px;
    background: rgba(255, 255, 255, 0);
    border: 2px solid #87888b;
  }
}
.mobile_loginContainer {
  padding: 1.22rem 0.64rem 0.64rem;
  margin: 0 auto;
}
</style>
